import { useTheme } from '@mui/material/styles';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { DashboardChartCard } from '../../../common/components';
import { materialCompactMoney, materialMoney } from '../../../utils/materialDisplay';
import {
  CHART_TICK_FONT_SIZE,
  KPI_LABELS,
  MATERIAL_TEXTS,
  STAGE_KEYS,
} from '../constants/materialDashboardConstants';

/**
 * Costos por etapa en la misma base de pesos que los indicadores.
 * @param {Object} props
 * @param {Object} [props.totals] Totales del resumen.
 * @param {boolean} props.isLoading Resumen en carga.
 * @returns {JSX.Element}
 */
const MaterialStageChart = ({ totals, isLoading }) => {
  const theme = useTheme();
  const tick = { fill: theme.palette.text.secondary, fontSize: CHART_TICK_FONT_SIZE };
  const stageColors = [
    theme.palette.primary.main,
    theme.palette.info.main,
    theme.palette.warning.main,
    theme.palette.success.main,
  ];
  const data = STAGE_KEYS.map((key) => ({ name: KPI_LABELS[key], amount: totals?.[key] ?? 0 }));

  return (
    <DashboardChartCard
      variant="plain"
      title={MATERIAL_TEXTS.stageCosts}
      loading={isLoading}
      hasData={Boolean(totals)}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 8, right: 20, left: 90, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis type="number" tickFormatter={materialCompactMoney} tick={tick} />
          <YAxis type="category" dataKey="name" width={170} tick={tick} />
          <RechartsTooltip formatter={materialMoney} />
          <Bar
            dataKey="amount"
            name={MATERIAL_TEXTS.pesos}
            radius={[0, 4, 4, 0]}
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell key={entry.name} fill={stageColors[index]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </DashboardChartCard>
  );
};

export default MaterialStageChart;
